import React, {useEffect, useLayoutEffect, useState} from 'react';
import Container from "react-bootstrap/Container";
import {useLocation, useNavigate} from "react-router-dom";
import {getAuthMenus} from "../../api/apiClient";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Swal from "sweetalert2";
import useAuth from "../../hook/useAuth";

const Frame = ({
                 propIsActiveHeader,
                 propIsActiveSidebar,
                 children
               }) => {

  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState(undefined);

  // 사용자 권한
  const [userAuthList, setUserAuthList] = useState(undefined);
  const [headerMenus, setHeaderMenus] = useState([]);
  const [headerMenusLv2, setHeaderMenusLv2] = useState([]);

  const [sidebarMenus, setSidebarMenus] = useState([]);
  const [sidebarMenuId, setSidebarMenuId] = useState(undefined);


  const [pageAuth, setPageAuth] = useState(undefined);

  useEffect(() => {
    if (propIsActiveHeader || propIsActiveSidebar) {
      getAuthMenus().then((res) => {
        console.log(res);
        if (res.data.data !== undefined) {
          console.log(res.data.data.list);
          setUserAuthList(res.data.data.list);
        }
      });
    }
  }, []);


  const [menusLv1, setMenusLv1] = useState({});
  const [menusLv2, setMenusLv2] = useState({});

  const [menusLv1AuthList, setMenusLv1AuthList] = useState({});
  const [menusLv2AuthList, setMenusLv2AuthList] = useState({});

  const [activeMenuLv1, setActiveMenuLv1] = useState({});
  const [activeMenuLv1Depth, setActiveMenuLv1Depth] = useState({});
  const [activeMenuLv2, setActiveMenuLv2] = useState({});

  useEffect(() => {
    console.log(userAuthList);
    if (Array.isArray(userAuthList)) {
      setMenusLv1(userAuthList.filter((item) => item.lv === 1));
      setMenusLv2(userAuthList.filter((item) => item.lv === 2));
      // setMenusLv2(userAuthList.filter((item) => item.lv === 2 && item.menu_id !== "DB00000020"));

      // console.log(location);
      const path = location.pathname.substring(3);
      console.log(path);

      /*userAuthList.map((item) => {
        if (path === item.URI) {
          setPageAuth(item.auth);
          sessionStorage.setItem('CURRENT_AUTH', item.auth);
        }
      });*/
    }

  }, [userAuthList]);

  useEffect(() => {
    console.log(menusLv1);

    if (Array.isArray(menusLv1)) {
      // eslint-disable-next-line array-callback-return
      menusLv1.map((item) => {
        if (item.auth !== 0) {
          setMenusLv1AuthList(menusLv1.filter((item) => item.auth !== 0));
        }
      });
    }
  }, [menusLv1]);

  useEffect(() => {
    console.log(menusLv1AuthList);

    const path = location.pathname.substring(4, 7);
    console.log(path);

    if (path === "bro") {
      // console.log("Broker~~~~~~~~~~~~~~~~~")
      setActiveMenuLv1({});
    } else {
      if (Array.isArray(menusLv1AuthList)) {
        setActiveMenuLv1(menusLv1AuthList.filter((item) => item.URI.includes(path)));
      }
    }

  }, [menusLv1AuthList]);


  useEffect(() => {
    console.log(menusLv2);

    if (Array.isArray(menusLv2)) {
      // eslint-disable-next-line array-callback-return
      menusLv2.map((item) => {
        if (item.auth !== 0) {
          setMenusLv2AuthList(menusLv2.filter((item) => item.auth !== 0));
        }
      });
    }
  }, [menusLv2]);

  useEffect(() => {
    console.log(menusLv2AuthList);

    if (Array.isArray(menusLv1AuthList)) {
      if (Array.isArray(menusLv2AuthList)) {
        console.log(menusLv1AuthList);
        console.log(menusLv2AuthList);

        const result = menusLv1AuthList.filter(item => {
          return !menusLv2AuthList.some(other => other.URI === item.URI);
        });

        console.log(result);

        const result2 = menusLv2AuthList.filter(item => {
          return result.some(other => other.menu_id === item.pid);
        });

        console.log(result2);

        const result3 = result.map((item) => {
          result2.some((item2) => {
            if (item.URI !== item2.URI) {
              if (item.menu_id === item2.pid) {
                return item.URI = item2.URI;
              }
            }
          });
          // return item;
        });

        console.log(result3);


        /*        const path = location.pathname.substring(3);
                console.log(path);

                const currPath = menusLv2AuthList.filter((item) => item.URI.includes(path));
                console.log(currPath);

                setPageAuth(currPath[0].auth);
                sessionStorage.setItem('CURRENT_AUTH', currPath[0].auth);*/


        /*menusLv1AuthList.map((item) => {

          console.log(item);
          console.log(item.URI);

          // const temp = menusLv2AuthList.filter((item2) => item2.pid.includes(item.menu_id));
          const temp = menusLv2AuthList.filter((element) => {
            console.log(element);
            console.log(element.URI);
          });

          console.log(incorrectURIItem);


          // console.log(temp);

          // menusLv2AuthList.map((item2) => {
          //   console.log(item.URI !== item2.URI);
          // });

          // const temp2 = menusLv2AuthList.filter((element) => element.URI !== item.URI);
          // console.log(temp);

          /!*if (temp.length === 0) {
            console.log(item);
            // incorrectURIItem.push(item);
          }*!/
        });*/

        // console.log(incorrectURIItem);

        /*if (incorrectURIItem !== undefined) {
          menusLv2AuthList.map((item) => {
            console.log(item);
            if (item.pid === incorrectURIItem.menu_id) {
              console.log(item);
              incorrectURIItem.URI = item.URI;
            }
          });

          setMenusLv1AuthList(menusLv1AuthList.filter((item) => item.pid !== incorrectURIItem.menu_id));
        }*/
        // incorrectURIItem.URI = "/";
        // console.log(incorrectURIItem);
      }
    }

  }, [menusLv2AuthList]);

  useEffect(() => {
    console.log(activeMenuLv1);

    if (Array.isArray(activeMenuLv1)) {
      setActiveMenuLv1Depth(menusLv2AuthList.filter((item) => item.pid.includes(activeMenuLv1[0].menu_id)));

      /*const menu = menusLv2AuthList.filter((item) => item.URI === activeMenuLv1[0].URI);
      console.log(menu);

      if (menu.length === 0) {
        console.log(activeMenuLv1Depth);
        // setActiveMenuLv1(prevState => ({...prevState, URI: menu[0].URI}));
      }*/
    }

  }, [activeMenuLv1]);

  useEffect(() => {
    console.log(activeMenuLv1Depth);
    if (Array.isArray(activeMenuLv1Depth)) {
      const path = location.pathname.substring(4);
      console.log(path);
      setActiveMenuLv2(activeMenuLv1Depth.filter((item) => item.URI.includes(path)));

      const menu = menusLv2AuthList.filter((item) => item.URI === activeMenuLv1[0].URI);
      console.log(menu);

      if (menu.length === 0) {
        console.log(activeMenuLv1Depth);

        const findIndex = activeMenuLv1.findIndex(element => element.lv === 1);
        // const findIndex = activeMenuLv1.findIndex(element => element.menu_id === "TR00000000");
        // console.log(findIndex);

        let copyArray = [...activeMenuLv1];
        copyArray[findIndex].URI = activeMenuLv1Depth[0].URI;
        setActiveMenuLv1(copyArray);
      }

    }
  }, [activeMenuLv1Depth]);

  useEffect(() => {
    console.log(activeMenuLv2);

    // const path = location.pathname.substring(3);
    // console.log(path);

    // const currPath = menusLv2AuthList.filter((item) => item.URI.includes(path));
    // console.log(currPath);

    if (!isEmptyObj(activeMenuLv2)) {
      // console.log(activeMenuLv2[0].auth);
      // setPageAuth(activeMenuLv2[0].auth);
      if (!sessionStorage.getItem('CURRENT_AUTH')) {
        sessionStorage.setItem('CURRENT_AUTH', activeMenuLv2[0].auth);
      }
      window.dispatchEvent(new Event('storage'));
    }

  }, [activeMenuLv2]);


  ////// 여기 관련된 코드 custom Hook 만들어보기 //////
  useEffect(() => {
    // console.log(pageAuth);

    /*const handleStorage = () => {
      // Place for a function responsible for
      // pulling and displaying local storage data
      // sessionStorage.setItem('CURRENT_AUTH', pageAuth);
      // window.dispatchEvent(new Event('storage'));
      console.log(sessionStorage.getItem('CURRENT_AUTH'));
      setPageAuth(sessionStorage.getItem('CURRENT_AUTH'));
    }

    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);*/

  }, []);

  const auth = useAuth();
  console.log(auth);

  /*useEffect(() => {
    const handleStorage = () => {
      // Place for a function responsible for
      // pulling and displaying local storage data
      sessionStorage.setItem('CURRENT_AUTH', pageAuth);
      window.dispatchEvent(new Event('storage'))
    }

    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, [])*/


  function isEmptyObj(obj) {
    return obj.constructor === Object && Object.keys(obj).length === 0;
  }

  useEffect(() => {
    if (Array.isArray(userAuthList)) {
      // eslint-disable-next-line array-callback-return
      userAuthList.map((item) => {
        if (item.lv === 1 && item.auth !== 0) {
          // setHeaderMenus(prevArray => [...prevArray, item]);
        } else if (item.lv === 2 && item.auth !== 0) {
          // setSidebarMenus(prevArray => [...prevArray, item]);
          /*if (item.menu_id === sidebarMenuId) {
            setPageAuth(item.auth);
            sessionStorage.setItem('CURRENT_AUTH', item.auth);
          }*/
          if (!isEmptyObj(activeMenuLv2)) {
            if (item.menu_id === activeMenuLv2[0].menu_id) {
              setPageAuth(item.auth);
              sessionStorage.setItem('CURRENT_AUTH', item.auth);
            }
          }
          if (item.menu_id.includes("10")) {
            // console.log(item);
            // setHeaderMenusLv2(prevArray => [...prevArray, item]);
          }
        }
      });
    }
  }, [userAuthList]);

  const navigate = useNavigate();

  useEffect(() => {
    console.log(pageAuth);

    if (pageAuth === '0') { // || pageAuth === undefined
      Swal.fire('접근이 불가능한 페이지입니다.');
      return navigate(-1);
    }
  }, [pageAuth]);


  /*useEffect(() => {
    // console.log(location.pathname);

    if (location.pathname.includes('dash')) {
      setActiveMenu('대시보드');
    } else if (location.pathname.includes('conf')) {
      setActiveMenu('구성관리');
    } else if (location.pathname.includes('fault')) {
      setActiveMenu('장애관리');
    } else if (location.pathname.includes('perf')) {
      setActiveMenu('성능관리');
    } else if (location.pathname.includes('traf')) {
      setActiveMenu('트래픽관리');
    } else if (location.pathname.includes('user')) {
      setActiveMenu('사용자관리');
    } else if (location.pathname.includes('sys')) {
      setActiveMenu('시스템관리');
    } else if (location.pathname.includes('broker')) {
      setActiveMenu('grafana');
    }
  }, [location]);*/

  return (
      <Container fluid className={'p-0 wrapper'}>
        {propIsActiveHeader ?
            <Header
                // propActiveMenu={activeMenu}
                // propMenus={headerMenus}
                // propSubMenus={headerMenusLv2}
                propActiveMenu={activeMenuLv1}
                propMenus={menusLv1AuthList}
                // propSubMenus={headerMenusLv2}
            />
            : ''}
        <div className={"main"}>
          {propIsActiveSidebar ?
              <Sidebar
                  /*propActiveMenu={activeMenu}
                  propMenus={sidebarMenus}
                  propSetSidebarMenuId={setSidebarMenuId}*/
                  propLocation={location.pathname}
                  propActiveMenuLv1={activeMenuLv1}
                  propActiveMenuLv2={activeMenuLv2}
                  propMenus={activeMenuLv1Depth}
                  // propLocation={location.pathname}
                  // propSetSidebarMenuId={setSidebarMenuId}
              />
              : ''}
          {children}
          {/*{pageAuth}*/}
        </div>
      </Container>
  );
};

export default Frame;
